import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/CtcMaster.api';

export const uploadCtcMasterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_REQUEST,
  payload: fileData,
});

export const uploadCtcMasterSuccess = (fileData) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_SUCCESS,
  payload: fileData,
});

export const uploadCtcMasterFailure = (error) => ({
  type: actionTypes.UPLOAD_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const uploadCtcMasterFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadCtcMasterRequest(fileData));
    try {
      const response = await api.uploadCtcMaster(fileData);
      dispatch(uploadCtcMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadCtcMasterFailure(error));
      return { success: false, message: error };
    }
  };
};
export const multiDaleteCtcMasterRequest = (ids) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_REQUEST,
  payload: ids,
});

export const multiDaleteCtcMasterSuccess = (message) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const multiDaleteCtcMasterFailure = (error) => ({
  type: actionTypes.MULTI_DELETE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const multiDeleteCtcMasterFile = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteCtcMasterRequest(ids));
    try {
      const response = await api.multiDeleteCtcMaster(ids);
      dispatch(multiDaleteCtcMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteCtcMasterFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getCtcMasterRequest = () => ({
  type: actionTypes.GET_SALARY_REGISTER_REQUEST,
});

export const getCtcMasterSuccess = (clients) => ({
  type: actionTypes.GET_SALARY_REGISTER_SUCCESS,
  payload: clients,
});

export const getCtcMasterFailure = (error) => ({
  type: actionTypes.GET_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const getCtcMaster = (current_month) => {
  return async (dispatch) => {
    dispatch(getCtcMasterRequest());
    try {
      const response = await api.fetchCtcMaster(current_month);
      dispatch(getCtcMasterSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getCtcMasterFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateCtcMasterRequest = (id, clientData) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_REQUEST,
  payload: { id, clientData },
});

export const updateCtcMasterSuccess = (message) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const updateCtcMasterFailure = (error) => ({
  type: actionTypes.UPDATE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const updateCtcMasterById = (id, salaryData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    salaryData.updated_by = user.user_name;

    dispatch(updateCtcMasterRequest(id, salaryData));
    try {
      const response = await api.updateCtcMaster(id, salaryData);
      dispatch(updateCtcMasterSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateCtcMasterFailure(error));
      return { success: false, message: error };
    }
  };
};
export const deleteCtcMasterRequest = (id) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_REQUEST,
  payload: id,
});

export const deleteCtcMasterSuccess = (message) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_SUCCESS,
  payload: message,
});

export const deleteCtcMasterFailure = (error) => ({
  type: actionTypes.DELETE_SALARY_REGISTER_FAILURE,
  payload: error,
});

export const deleteCtcMasterById = (id) => {
  return async (dispatch) => {
    dispatch(deleteCtcMasterRequest(id));
    try {
      const response = await api.deleteCtcMaster(id);
      dispatch(deleteCtcMasterSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteCtcMasterFailure(error));
      return { success: false, message: error };
    }
  };
};
